export const KATALOG_ELEMENT_GUIDS = {
  verktoy_detaljside: 'e2604678-2f81-40ef-9b78-0abf424d9caa',
  verktoy_eksternt_uthopp: 'c22d926b-a8c2-450f-a550-4d471416c947',
  finn_verktoy: 'e22851a6-1b44-4557-b396-31db3d1a93e1',
} as const;

export const PARAMS = {
  verktoyId: 'verktoyId',
  aktivitetId: 'aktivitetId',
  separator: ';',
} as const;
